import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Button, Card, Chip, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';

const guestData = [
  {
    name: 'Emma Thompson',
    booking: 'Botel Sunrise – Room 304 - May 10-15, 2025',
    warnings: 0,
    status: 'Active',
  },
  {
    name: 'Michael Johnson',
    booking: 'Botel Horizon – Room 102 - May 8-12, 2025',
    warnings: 2,
    status: 'Overstay Risk',
  },
  {
    name: 'Sarah Williams',
    booking: 'Botel Marina – Room 208 - May 5-10, 2025',
    warnings: 1,
    status: 'Flagged',
  },
];

const statusColor = (status: string) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Overstay Risk':
      return 'warning';
    case 'Flagged':
      return 'error';
    default:
      return 'default';
  }
};

const GuestManagement = () => (
  <Card sx={{ p: 3, background: '#181F2A', boxShadow: 3, position: 'relative' }}>
    <Typography variant="h6" sx={{ color: '#fff', mb: 2, fontWeight: 700 }}>
      Guest Management
    </Typography>
    <Box sx={{ display: 'flex', mb: 2 }}>
      <TextField
        variant="outlined"
        placeholder="Search by Guest ID or Name"
        size="small"
        sx={{ background: '#232B3E', borderRadius: 1, input: { color: '#fff' }, flex: 1 }}
        InputProps={{ style: { color: '#fff' } }}
      />
      <Button variant="contained" sx={{ ml: 2, background: '#3456D5', minWidth: 100 }} startIcon={<SearchIcon />}>
        Search
      </Button>
    </Box>
    <TableContainer component={Paper} sx={{ background: 'transparent' }}>
      <Table>
        <TableHead>
          <TableRow sx={{ background: '#232B3E' }}>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Guest Name</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Current Booking</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Overstay Warnings</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Status</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {guestData.map((guest, idx) => (
            <TableRow key={idx} sx={{ background: idx % 2 ? '#1C2533' : 'transparent' }}>
              <TableCell sx={{ color: '#fff' }}>{guest.name}</TableCell>
              <TableCell sx={{ color: '#fff' }}>{guest.booking}</TableCell>
              <TableCell sx={{ color: '#fff' }}>{guest.warnings}</TableCell>
              <TableCell>
                <Chip
                  label={guest.status}
                  color={statusColor(guest.status)}
                  size="small"
                  sx={{ fontWeight: 700 }}
                />
              </TableCell>
              <TableCell>
                <IconButton color="primary">
                  <EditIcon />
                </IconButton>
                <IconButton color="error">
                  <DeleteIcon />
                </IconButton>
                <IconButton color="warning">
                  <WarningAmberIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        backdropFilter: 'blur(2px)',
        pointerEvents: 'none',
      }}
    >
      <Typography
        sx={{
          color: '#9ca3af',
          fontSize: 24,
          fontWeight: 'bold',
          mb: 1,
        }}
      >
        Coming Soon
      </Typography>
      <Typography
        sx={{
          color: '#6b7280',
          fontSize: 16,
          textAlign: 'center',
          px: 2,
        }}
      >
        This feature will be available in a future release
      </Typography>
    </Box>
  </Card>
);

export default GuestManagement; 